// https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener

let passiveSupported = false;

try {
  const options = Object.defineProperty({}, 'passive', {
    // TODO: check this

    get: function () {
      passiveSupported = true;
      return undefined;
    },
  });

  window.addEventListener('test', options, options);
  window.removeEventListener('test', options, options);
} catch {
  passiveSupported = false;
}

export default passiveSupported;
